<script>
import config from '../../common/genericPanelConf';

import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import GenericDateMaskV2 from '../../components/generic/GenericDateMaskV2.vue';
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue'

import { required  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';

export default{
  setup: () => ({ v$: useVuelidate() }),

  components: {
    GenericDateMaskV2,
    GenericBooleanDropdown,
    GenericDataTable,
    ResponsiveButton,
    GenericCustomMasterDataAutocompleteV2
},
  data(){
    return {
      filters: {
        dateFrom: new Date().setMonth((new Date()).getMonth() - 1),
        isClosed: false,
        idRegistryPlant: CommonConstants.defaultPlantId
      },
      configuration: {},
      submitted: false,
    }
  },
  validations(){
      return {
          filters: {
              dateFrom: {required},
              isClosed: {},
              idRegistryPlant: {}
          }
      }
  },
  created(){
    this.configuration = config.getConfiguration('FiscalNotificationList');
  },
  computed: {
    utils(){
      return Utils;
    },
  },
  mounted() {
    this.$store.dispatch('security/setNavbarTitle', 'fiscalNotification.page_title');
    this.loadFromCache();
  },
  watch: {
    'filters.idRegistryPlant'(){
      this.load(!this.v$.$invalid);
    }
  },
  methods: {
    load(valid) {
      this.submitted = true;
      if(valid){
        let filters = {
          isClosed: this.filters.isClosed,
          idRegistryPlant: this.filters.idRegistryPlant,
          dateFrom: Utils.formatDateForAPI(this.filters.dateFrom)
        }
        this.saveCache();
        this.$refs.fiscalNotificationGrid.filterFromView(filters, true);
        this.submitted = false;
      }
    },
    showToast(success, message) {
      if(success){
        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
      }else{
        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
      }
    },
    loadFromCache(){
      let cacheData = this.$store.getters['cacheDataStore/getGridCache']('FiscalNotification');
      if(cacheData){
        this.filters = cacheData;
        this.load(!this.v$.$invalid);
      }
    },
    saveCache(){
      let cacheData = {
        name: 'FiscalNotification',
        filters: {
          isClosed: this.filters.isClosed,
          idRegistryPlant: this.filters.idRegistryPlant,
          dateFrom: Utils.formatDateForAPI(this.filters.dateFrom)
        }
      };
      this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
    },
    goToCommunication(){
      if(this.$refs.fiscalNotificationGrid.selectedItem){
          this.$router.push({name: 'last-fiscal-notification', query: {idScheduledOperation: this.$refs.fiscalNotificationGrid.selectedItem.idOperativePlanScheduledOperation}})
      }
    },
  }
}

</script>

<template>
  <main>
    <div class="m-5">
      <div class="grid">
        <div class="col-4">
          <label for="isClosed" :class="{'p-error':v$.filters.isClosed.$invalid && submitted}">{{$t('fiscalNotificationList.isClosed')}}</label>
          <GenericBooleanDropdown
            id="isClosed" 
            v-model="filters.isClosed" 
            class="w-full p-inputtext-sm mt-1 " />
          <div v-if="(v$.filters.isClosed.$invalid && submitted) || v$.filters.isClosed.$pending.$response">
            <small class="p-error" v-for="error in v$.filters.isClosed.$silentErrors" :key="error.$validator">
                {{error.$message}}
            </small>
          </div>
        </div>
        <div class="col-4">
          <label for="plant" :class="{'p-error':v$.filters.idRegistryPlant.$invalid && submitted}">{{$t('fiscalNotificationList.plant')}}</label>
          <GenericCustomMasterDataAutocompleteV2
            field="label"
            v-model="filters.idRegistryPlant"
            :selectFirst="true"
            api="masterdata/registry-plant-combo"
            :format="{ label: 'label', value: 'value' }"
            :addEmpty="true"
            :emptyValue="null"
            :emptyLabel="$t('all')"
            name="plants"
            class="p-inputtext-sm w-full" />
          <div v-if="(v$.filters.idRegistryPlant.$invalid && submitted) || v$.filters.idRegistryPlant.$pending.$response">
            <small class="p-error" v-for="error in v$.filters.idRegistryPlant.$silentErrors" :key="error.$validator">
                {{error.$message}}
            </small>
          </div>
        </div>
        <div class="col-4">
          <label for="dateFrom" :class="{'p-error':v$.filters.dateFrom.$invalid && submitted}">{{$t('fiscalNotificationList.dateFrom')}}</label>
          <GenericDateMaskV2 
            v-model="filters.dateFrom" 
            mask="99/99/9999"
            :unmask="true"
            inputClass="w-full"
            class="w-full p-inputtext-sm mt-1" />
          <div v-if="(v$.filters.dateFrom.$invalid && submitted) || v$.filters.dateFrom.$pending.$response">
            <small class="p-error" v-for="error in v$.filters.dateFrom.$silentErrors" :key="error.$validator">
                {{error.$message}}
            </small>
          </div>
        </div>
        <div class="col-12 lg:col-7">
          <ResponsiveButton :label="$t('btn.refresh')" icon="pi pi-replay" class="mx-1" @click="load(!v$.$invalid)"/>
          <!-- <SplitButton label="Verbali" icon="pi pi-file" :model="reportBtnItems"  class="mx-1"></SplitButton> -->
          <ResponsiveButton :label="$t('btn.viewDetails')" icon="pi pi-file" class="mx-1" @click="goToCommunication"/>
        </div>
        <div class="col-12">
          <GenericDataTable :configuration="configuration" ref="fiscalNotificationGrid"/>
        </div>
      </div>
    </div>
  </main>
</template>

<style scoped>

.p-datatable {
  overflow-x: auto;
}

.field > label {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}

</style>